export const baseAPIUrl = `${process.env.REACT_APP_API_HOST}/api/v1`;
